import { render, staticRenderFns } from "./etre-appele-TNG.vue?vue&type=template&id=7c979b64&scoped=true"
import script from "./etre-appele-TNG.vue?vue&type=script&lang=ts"
export * from "./etre-appele-TNG.vue?vue&type=script&lang=ts"
import style0 from "./etre-appele-TNG.vue?vue&type=style&index=0&id=7c979b64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c979b64",
  null
  
)

export default component.exports